import React from 'react';
import FieldGroup from '../field_group/FieldGroup';
import Form from '../form/Form';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { getErrorValue, stringifyErrorMessage } from '../../utils/utility';
import { requiredValidator } from '../field_group/validators';
import { Alert, Tab, Tabs } from 'react-bootstrap';
import LuminaireDataTable from './LuminaireDataTable';
import BallastDataTable from './BallastDataTable';

export class LightingSetDetail extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = undefined;

    this.state = {
      tabActiveKey: 1,
    };
  }

  getLSData() {
    return this.formRef.getFormData();
  }

  renderBasicInfo() {
    const {
      name,
      description,
      power_required,
      image,
    } = this.props.lightingSet || {};

    const { t, disabled, fieldErrors, errorMessage, ...otherAttr } = this.props;
    const customAttr = { disabled };

    return (
        <Form image={image} {...otherAttr} ref={ref => (this.formRef = ref)}>
        <FieldGroup
          id="lighting-set-name"
          field="name"
          type="text"
          label={t('name')}
          placeholder={t('lighting set name')}
          value={name}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'name')}
          {...customAttr}
        />
        <FieldGroup
          id="lighting-set-power-required"
          type="number"
          label={<span>{t('power (W)')}</span>}
          placeholder="0"
          value={power_required}
          readOnly={true}
          {...customAttr}
        />
        <FieldGroup
          id="lighting-set-description"
          field="description"
          componentClass="textarea"
          label={t('description')}
          value={description}
          {...customAttr}
        />
      </Form>
    );
  }

  renderLuminaire() {
    const {
      t,
      mode,
      lightingSet: { id, bulb_list },
    } = this.props;

    return (
      <Tab eventKey={2} title={t('luminaire')}>
        <LuminaireDataTable
          lightingSetId={id}
          luminaires={bulb_list}
          mode={mode}
          onEditItem={item => this.setState({ selectedItem: item })}
        />
      </Tab>
    );
  }

  renderBallast() {
    const {
      t,
      mode,
      lightingSet: { id: lightingSetId, ballast_list },
    } = this.props;

    return (
      <Tab eventKey={3} title={t('ballast')}>
        <BallastDataTable
          lightingSetId={lightingSetId}
          ballasts={ballast_list}
          mode={mode}
          onEditItem={item => this.setState({ selectedItem: item })}
        />
      </Tab>
    );
  }

  renderErrorMessage(errorMessage) {
    if (!errorMessage) return null;
    return (
      <Alert
        bsStyle="danger"
        style={{ 'white-space': 'pre' }}
      >
        {errorMessage}
      </Alert>
    );
  }

  render() {
    const { t, errorMessage } = this.props;
    const { tabActiveKey } = this.state;
    const detailError = stringifyErrorMessage(errorMessage);
    return (
      <React.Fragment>
        {detailError ? this.renderErrorMessage(detailError) : null}
        <Tabs
          id="ls-tabs"
          activeKey={tabActiveKey}
          onSelect={key => this.setState({ tabActiveKey: key })}
        >
          <Tab
            eventKey={1}
            title={t('basic info')}
          >
            {this.renderBasicInfo()}
          </Tab>
          {this.renderLuminaire()}
          {this.renderBallast()}
        </Tabs>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => (
  {
  isCreating: state.lighting.lightingset.isCreating,
  errorMessage: state.lighting.lightingset.errorMessage,
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    null,
    null,
    { withRef: true },
  )(LightingSetDetail),
);



// WEBPACK FOOTER //
// ./src/components/light/LightingSetDetail.js